<template>
  <div class="table">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="container">
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_QBR_EXPORT_HIST_PERF">导出</el-button>
      </el-row>
      <el-table :data="tableData" :span-method="objectSpanMethod1" max-height="760" ref="fpaPcnList" border highlight-current-row show-overflow="ellipsis">
        <el-table-column prop="measurements" label="Measurements" width="210"></el-table-column>
        <el-table-column prop="yearProduct" label="Year或产品" width="100"></el-table-column>
        <el-table-column v-for="(item,index) in groupList[0].facilityList" :key="index" align="center" :label="item.facilityName" show-overflow-tooltip min-width="120">
          <template slot="header">
            <p>{{item.facilityName}}</p>
          </template>
          <template slot-scope="scope">
            <!--拼接 个别红-->
            <div v-if="scope.row.measurements==='Feedback\n（绝对量+投诉率）'">
              <span v-for="(v,i) in scope.row.facilityDataList[index].dataDetailList" :key="i">
                <!-- <span @click="click(v)">chakkan1</span> -->
                <span :class="{'orangeClass':v.attrOneColor==='orange','greenClass':v.attrOneColor==='green','redClass':v.attrOneColor==='red','blackClass':!v.attrOneColor}">{{v.attrOne}}&nbsp;</span>
              </span>
            </div>
            <div v-if="scope.row.measurements==='QIP'">
              <span v-for="(v,i) in scope.row.facilityDataList[index].dataDetailList" :key="i">
                <!-- <span @click="click(v)">chakkan1</span> -->
                <span :class="{'orangeClass':v.attrOneColor==='orange','greenClass':v.attrOneColor==='green','redClass':v.attrOneColor==='red','blackClass':!v.attrOneColor}">{{v.attrOne}}&nbsp;</span>
              </span>
            </div>
            <!-- 换行显示  要红都红-->
            <div v-if="scope.row.measurements==='MSV'">
              <div v-for="(v,i) in scope.row.facilityDataList[index].dataDetailList" :key="i">
                <!-- <span @click="click(v)">chakkan1</span> -->
                <p :class="{'redClass':v.attrOneColor==='red','greenClass':v.attrOneColor==='green','blackClass':!v.attrOneColor}">{{v.attrOne}}&nbsp;</p>
              </div>
            </div>
            <!-- 换行显示 个别红-->
            <div v-if="scope.row.measurements==='sensory'">
              <div v-for="(v,i) in scope.row.facilityDataList[index].dataDetailList" :key="i">
                <!-- <span @click="click(v)">chakkan1</span> -->
                <p>
                  <span :class="{'redClass':v.attrOneColor==='red','greenClass':v.attrOneColor==='green','blackClass':!v.attrOneColor}">{{v.attrOne}}</span>
                  &nbsp;
                  <span v-for="(ele,idx) in v.attrTwo.split(' ')" :key="idx" :class="Number(ele)<70?'redClass':'blackClass'">{{ele}}&nbsp;</span>
                </p>
              </div>
            </div>
            <!-- 拼接 个别红-->
            <div v-if="scope.row.measurements==='SQMS'">
              <span v-for="(v,i) in scope.row.facilityDataList[index].dataDetailList" :key="i">
                <!-- <span @click="click(v)">chakkan1</span> -->
                <span :class="{'redClass':v.attrOneColor==='red','greenClass':v.attrOneColor==='green','blackClass':!v.attrOneColor}">{{v.attrOne}}&nbsp;</span>
              </span>
            </div>
            <!-- 换行 个别红-->
            <div v-if="scope.row.measurements==='AAA'">
              <span v-for="(v,i) in scope.row.facilityDataList[index].dataDetailList" :key="i">
                <!-- <span @click="click(v)">chakkan1</span> -->
                <p>
                  <span :class="{'redClass':v.attrOneColor==='red','greenClass':v.attrOneColor==='green','blackClass':!v.attrOneColor}">{{v.attrOne}}</span>
                  &nbsp;
                  <span :class="{'redClass':v.attrTwoColor==='red','greenClass':v.attrTwoColor==='green','blackClass':!v.attrTwoColor}">{{v.attrTwo}}</span>
                  &nbsp;
                  <span :class="{'redClass':v.attrThreeColor==='red','greenClass':v.attrThreeColor==='green','blackClass':!v.attrThreeColor}">{{v.attrThree}}</span>
                </p>
              </span>
            </div>
            <div v-if="scope.row.measurements==='previous QBR results & comments'&&isRoles">
              <div v-for="(v,i) in scope.row.prePerformDataDetailList[0].performanceValueList" :key="i" style="text-align:left">
                <p>{{v.split('\n')[0]}}</p>
                <p>{{v.split('\n')[1]}}</p>
                <p>{{v.split('\n')[2]}}</p>
                <p>{{v.split('\n')[3]}}</p>
                <p>{{v.split('\n')[4]}}</p>
                <p>{{v.split('\n')[5]}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";
export default {
  data() {
    return {
      tableData: [],
      groupList: [],
      groupCodeList: [],
      prePerformDataList: [],
      merge: [],//存放需要合并的行
      pos: "",//需要合并行下标
      isRoles: true,
    }
  },
  created() {
    let ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    console.log('ms_roles', ms_roles);
    if (ms_roles.indexOf('QSPI_QBR_SUPP') !== -1) {
      this.isRoles = false
    } else {
      this.isRoles = true
    }
    console.log('isRoles', this.isRoles);
    this.getDetailInfo()
  },
  methods: {
    onExport() {
      this.groupCodeList.push(this.$route.query.groupCode)
      QBRApi.performanceDownload({
        // groupCodeList: ["G2021068","G2021109","G2021072"]
        groupCodeList: this.groupCodeList
      }).then(res => {
        fileService.respToFile(res, '供应商历史表现报表.xlsx');
      });
    },
    getDetailInfo() {
      this.groupCodeList.push(this.$route.query.groupCode)
      let ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
      QBRApi.qbrPerformance({
        groupCodeList: this.groupCodeList
      }).then(res => {
        console.log('获取qbr历史表现', res);
        this.groupList = res.data.groupList
        if (ms_roles.indexOf('QSPI_QBR_SUPP') !== -1) {
          this.tableData = this.tableData.concat(res.data.feedbackDataList,res.data.qipDataList, res.data.msvDataList, res.data.sensoryDataList, res.data.sqmsDataList, res.data.tripleaDataList)
        } else {
          this.tableData = this.tableData.concat(res.data.feedbackDataList,res.data.qipDataList, res.data.msvDataList, res.data.sensoryDataList, res.data.sqmsDataList, res.data.tripleaDataList, res.data.prePerformDataList)
        }
        // this.prePerformDataList = res.data.prePerformDataList
        this.getSpanArr1()
        console.log('tableData', this.tableData);
      });
    },
    getSpanArr1() {
      console.log('this.tableData', this.tableData);
      for (let i = 0; i < this.tableData.length; i++) {
        if (i === 0) {
          this.merge.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一元素是否相同,根据相同id进行合并,
          if (this.tableData[i].measurements === this.tableData[i - 1].measurements) {
            this.merge[this.pos] += 1
            this.merge.push(0)
          } else {
            this.merge.push(1)
            this.pos = i
          }
        }
      }
      console.log('this.merge', this.merge);
      console.log('this.pos', this.pos);
    },
    objectSpanMethod1({ row, column, rowIndex, columnIndex }) {
      // console.log('row', row);
      // console.log('column', column);
      // console.log('rowIndex', rowIndex);
      // console.log('columnIndex', columnIndex);
      //用于设置要合并的行
      if (columnIndex === 0) {
        const _row = this.merge[rowIndex]
        console.log('_row', _row);
        const _col = _row > 0 ? 1 : 0
        console.log('_col', _col);
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      if (row.measurements === 'previous QBR results & comments') {
        if (columnIndex > 1 && columnIndex < 3) {
          // return [2, 3, 4];
          // 横占一个单元格,竖占3个单元格
          return {
            rowspan: 1,
            colspan: this.groupList[0].facilityList.length,
          }
        } else if (columnIndex > 2) {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    routerBack() {
      this.$router.push("/qspiQBR")
    },
  }
}
</script>

<style>
</style>